export const SET_TERM = 'df/SET_TERM';
export const SET_EXPANDED_CARD = 'df/SET_EXPANDED_CARD';
export const RESET_FILTERS = 'df/RESET_FILTERS';
export const REMOVE_FILTER = 'df/REMOVE_FILTER';
export const SET_SELECTED = 'df/SET_SELECTED';
export const RESET_SELECTION = 'df/RESET_SELECTION';
export const UPDATE_TOAST = 'df/UPDATE_TOAST';
export const ADD_BOOKMARK_ITEM = 'df/ADD_BOOKMARK_ITEM';
export const REMOVE_BOOKMARK_ITEM = 'df/REMOVE_BOOKMARK_ITEM';
export const BOOKMARKS_SET = 'df/BOOKMARKS_SET';
export const REMOVE_BOOKMARK_GROUP = 'df/REMOVE_BOOKMARK_GROUP';
export const SET_ATTRIBUTES = 'df/SET_ATTRIBUTES';
export const SET_FILTER_PARAMS = 'df/SET_FILTER_PARAMS';
export const SET_LOGIN_STATUS = 'df/SET_LOGIN_STATUS';
export const UPDATE_STATE = 'df/UPDATE_STATE';
export const SET_TOTAL_DOWNLOADS = 'df/SET_TOTAL_DOWNLOADS';
export const SET_AVAILABLE_FILTERS = 'df/SET_AVAILABLE_FILTERS';
